// actions/authActions.js
import { setLocalStorageOnUserAuthentication, clearLocalStorageOnUserLogout, makeAuthenticatedRequest } from './authHelpers';
import { setUserData } from '../slices/user.slice';
import { fetchPortfoliosInBatches } from '../../api/portfolioApi';
import { fetchUpcomingEvents } from '../../api/tickersApi';
import { HOSTNAME } from '../../configs/Domain';

// Helper to handle login
export const login = (username, password, setIsLoggedIn, setLoginFailed) => async (dispatch) => {
  try {
    const response = await fetch(`${HOSTNAME}/auth/login/credentials`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ u: username, p: password }),
    });

    const data = await response.json();
    if (response.status !== 200) {
      setLoginFailed(true);
      setIsLoggedIn(false);
      throw new Error(data.message || 'Login failed');
    }

    setIsLoggedIn(true);
    const userData = data.data;

    // Reuse helper to set localStorage
    setLocalStorageOnUserAuthentication(data.token, userData);

    // Dispatch user data to redux store
    dispatch(setUserData(userData));

    // Fetch portfolios and events with reusable function
    dispatch(fetchUserData(userData));

  } catch (error) {
    console.error('Authentication failed:', error);
  }
};

// Helper to validate JWT token
export const checkIfAuthorized = () => async (dispatch) => {
  try {
    const data = await makeAuthenticatedRequest(`${HOSTNAME}/auth/validate`);

    const userData = data.user;
    setLocalStorageOnUserAuthentication(data.token, userData);
    dispatch(setUserData(userData));

    // Fetch portfolios and events with reusable function
    dispatch(fetchUserData(userData));

    return true;
  } catch (error) {
    console.error('Authorization check failed:', error);
    clearLocalStorageOnUserLogout();
    return false;
  }
};

// Helper to fetch portfolios and events (used in both login and authorization)
export const fetchUserData = (userData) => async (dispatch) => {
  if (userData?.portfolios_v2) {
    const portfolioIds = userData.portfolios_v2.map(p => p.id);
    dispatch(fetchPortfoliosInBatches({
      userId: userData.uid,
      portfolioIds,
      userObjects: userData.portfolios_v2,
    }));
  }

  if (userData?.tickers) {
    dispatch(fetchUpcomingEvents(userData.tickers));
  }
};
// Logout action to clear localStorage and reset redux store
export const logout = () => async (dispatch) => {
  try {
    // Optionally, call the server to invalidate the session
    await fetch(`${HOSTNAME}/auth/logout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include' // If you're using cookies, include credentials
    });

    // Clear local storage
    clearLocalStorageOnUserLogout();

    // Dispatch action to reset user data in redux store
    dispatch(setUserData(null)); // Resetting the user data

  } catch (error) {
    console.error('Logout failed:', error);
    // Handle errors appropriately here
  }
};